/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2022 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { ReactNode } from 'react';
import { Nav } from 'react-bootstrap';
import { labels } from '@umati/dashboard-common';
import { Link, useParams } from 'react-router-dom';

interface TabProps {
  default: string;
  /**
   * The string to append at the end of the TabLinks urls. If params[pramToAppendToLinks] is defined it is appended,
   * otherwise the string paramToAppendToLinks is appended. If not defined nothing is appended.
   */
  paramToAppendToLinks?: string;
  tabElements: ITab[];
}

export interface ITab {
  link: string;
  icon?: string;
  node: ReactNode;
  id: string;
}

type TabParams = {
  selected: string;
};

function getOwnProps(params) {
  return {
    match: {
      params,
    },
  };
}

export default function Tabs({ default: defaultTab, paramToAppendToLinks, tabElements }: TabProps) {
  const params = useParams<TabParams>();
  const urlPostfix = (paramToAppendToLinks ? params[paramToAppendToLinks] : '') || paramToAppendToLinks || '';

  return (
    <>
      <div className="container tabs">
        <Nav variant="tabs" defaultActiveKey={params.selected || defaultTab}>
          {tabElements.map((tab) => (
            <Nav.Item key={`navItem-${tab.id}`}>
              <Nav.Link eventKey={tab.id} as={Link} to={`${tab.link}/${urlPostfix}`}>
                <span className="d-none d-sm-inline">
                  <span className={tab.icon} title={labels[tab.id]}></span>
                </span>
                <span>{labels[tab.id]}</span>
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
      </div>
      {tabElements
        .filter((tab) => params.selected === tab.id)
        .map((tab) => {
          if (React.isValidElement(tab.node)) {
            return React.cloneElement(tab.node, { key: tab.id, ...getOwnProps(params) });
          }
          return <></>;
        })}
    </>
  );
}
